import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { withRouter } from 'react-router-dom';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import {
    pessoaService,
    eventoService,
    subeventoService,
    areaService,
    Utils,
    ouvinteService,
} from '../../services';
import PrincipalMaster from '../master/Principal';
import PublicMaster from '../master/Public';

const styles = {
    content: {
        padding: 16,
    },
};

class InscricaoOuvinte extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tituloEvento: '',
            isPosting: false,
            nome: '',
            email: '',
            emailErrorText: 'Campo obrigatório',
            dsSubeventos: [],
            dsAreas: [],
            eventoSelecionado: -1,
            subeventoSelecionado: 0,
            areaSelecionada: 0,
        };
    }

    async componentWillMount() {
        if (this.props.match.params.evento) {
            const evento = await Utils.getBase64Decode(this.props.match.params.evento);
            await this.buscarSubEventosPeloEvento(evento);
        }
    }

    async onSalvarOuvinte(event) {
        event.preventDefault();
        const { areaSelecionada, nome, email } = this.state;

        try {
            const response = await ouvinteService.save({ area: areaSelecionada, nome, email });
            Utils.showToast(response.message);
            // console.log(response);
            if (response.codigoOuvinte) {
                this.props.history.push(`/ouvinte/pagamento/${response.codigoOuvinte}`);
            }
        } catch (error) {
            Utils.showToast(error.message);
        }
    }

    async setArea(area) {
        this.setState({ areaSelecionada: area });
    }

    async buscarSubEventosPeloEvento(evento) {
        const dadosSubevento = await subeventoService.getSubeventosParaOuvintesDoEvento(evento);
        const nome = await eventoService.getEvento(evento);
        this.setState({
            dsSubeventos: dadosSubevento,
            eventoSelecionado: evento,
            tituloEvento: nome.NOME,
        });
        if (dadosSubevento.length === 1) {
            this.buscarAreasPeloSubEvento(dadosSubevento[0].CODIGO);
        }
    }

    async buscarAreasPeloSubEvento(subevento) {
        const areas = await areaService.getAreas(subevento);
        this.setState({ dsAreas: areas, subeventoSelecionado: subevento });
    }

    async buscarPessoaPeloEmail(value) {
        const pessoa = await pessoaService.getNomeByValue(value);

        if (pessoa.length !== 0) {
            const {
                eventoSelecionado,
            } = this.state;
            this.setState({ nome: pessoa[0].NOME });
            const response = await ouvinteService.getOuvinteEstaInscrito(value, eventoSelecionado);
            if (response.sucesso) {
                if (!response.PAGO && !response.LINKBOLETO) {
                    this.props.history.push(`/ouvinte/pagamento/${response.CODIGO}`);
                } else {
                    this.props.history.push(`/inscricao-ouvinte/resumo/${response.CODIGO}`);
                }
            }
        }
    }

    validarEmail(value) {
        if (!Utils.isEmailValido(value)) {
            this.setState({ emailErrorText: 'E-mail inválido.', email: value });
            return false;
        }
        this.setState({ emailErrorText: '', email: value });
        return true;
    }

    render() {
        const {
            tituloEvento,
            isPosting,
            nome,
            email,
            emailErrorText,
            dsSubeventos,
            dsAreas,
            subeventoSelecionado,
            areaSelecionada,
        } = this.state;
        const isTodosCamposValidos = !!nome && !emailErrorText;
        const MasterPage = Utils.getUsuarioEstaLogado() ? PrincipalMaster : PublicMaster;

        return (
            <MasterPage title="Inscrição para Ouvinte">
                <div style={styles.content}>
                    <h2>{tituloEvento}</h2>
                    <form onSubmit={e => this.onSalvarOuvinte(e)}>
                        <SelectField
                            floatingLabelText="Selecione um subevento"
                            value={subeventoSelecionado}
                            onChange={(_event, _index, value) => this.buscarAreasPeloSubEvento(value)}
                            fullWidth
                        >
                            <MenuItem value={0} primaryText=" " />
                            {
                                dsSubeventos.map(subevento => (
                                    <MenuItem key={subevento.CODIGO} value={subevento.CODIGO} primaryText={subevento.NOME} />
                                ))
                            }
                        </SelectField>
                        <SelectField
                            floatingLabelText="Selecione uma área"
                            value={areaSelecionada}
                            onChange={(_event, _index, value) => this.setArea(value)}
                            errorText={areaSelecionada > 0 ? '' : 'Campo obrigatório'}
                            fullWidth
                        >
                            <MenuItem value={0} />
                            {
                                dsAreas.map(area => (
                                    <MenuItem key={area.CODIGO} value={area.CODIGO} primaryText={area.NOME} />
                                ))
                            }
                        </SelectField>
                        <TextField
                            ref={(ref) => { this.emailRef = ref; }}
                            type="email"
                            floatingLabelText="E-mail do Ouvinte"
                            required
                            errorText={!email ? 'Campo obrigatório' : emailErrorText}
                            onChange={e => this.validarEmail(e.target.value)}
                            onBlur={e => this.buscarPessoaPeloEmail(e.target.value)}
                            value={email}
                            fullWidth
                        />
                        <br />
                        <TextField
                            floatingLabelText="Nome Completo do Ouvinte (nome que constará no certificado)"
                            required
                            errorText={nome ? '' : 'Campo obrigatório'}
                            onChange={e => this.setState({ nome: e.target.value })}
                            value={nome}
                            fullWidth
                        />
                        <br />
                        <RaisedButton
                            label="CONFIRMAR INSCRIÇÃO"
                            primary
                            type="submit"
                            disabled={isPosting || !isTodosCamposValidos}
                        />
                    </form>
                    <br />
                </div>
            </MasterPage>
        );
    }
}

export default withRouter(InscricaoOuvinte);
